/**
 * 左侧目录
 */
export default {
  dbl_menu_folder: '目录 ',
  dbl_menu_subfolder: '子目录 ',
  dbl_menu_menu: '菜单',
  dbl_menu_name: '名称',
  dbl_menu_chinese: '中文',
  dbl_menu_menu_level: '权限级别',
  dbl_menu_enter_dashboard_name: '请输入报表英文名',
  dbl_menuenter_dashboard_ch_name: '请输入报表中文名',
  dbl_menu_select_no_data: '暂无数据',
  dbl_menu_select_null: '请选择菜单',
  dbl_menu_folder_select_null: '请选择目录',
  dbl_menu_user_level_select_null: '请选择权限级别',
  dbl_menu_subfolder_select_null: '请选择子目录',

  dbl_menu_folder_name_null: '不可为空，且不超过50字符',
  dbl_menu_subfolder_name_null: '不可为空，且不超过50字符',
  dbl_menu_menu_name_null: '不可为空，且不超过50字符 ',
  dbl_menu_dashboard_name_null: '不可为空，且不超过50字符 ',
  dbl_menu_must_contain_less: '长度不超过50字符',
  dbl_menu_info_name_err: '仅支持输入汉字、字母和数字',
  dbl_menu_dashboard_re_enter: '已存在，请重新输入',
};